module.exports = __webpack_public_path__ + "img/undo.579b60b1.svg";